import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.css']
})
export class BankDetailsComponent implements OnInit {

  disabledControl: boolean = false;
  bankUser: any;
  submitted: boolean = true;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  token = this.authService.getToken();

  constructor(
    private authService: AuthService,
    private loginService: LoginService,
    private alertService: AlertService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  customerBankAccountSetupForm: FormGroup = new FormGroup(
    {
      NameOfBank: new FormControl('', [Validators.required]),
      BankRoutingNumber: new FormControl('', [
        Validators.required,
        Validators.pattern("^[0-9]*$")
      ]),
      CompanyTaxId: new FormControl(''),
      BankAddress: new FormControl(''),
      // PaymentEmailAddress: new FormControl('', [
      //   Validators.email,
      //   Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      AccountNumber: new FormControl('', [Validators.required]),
      ConfirmAccNum: new FormControl('', [Validators.required]),
      AccountType: new FormControl(''),
      PaymentSelection: new FormControl(''),
      BankZipCode: new FormControl('', [
        Validators.minLength(5),
        Validators.maxLength(7)]),
      BankContactPhone: new FormControl('', [
        Validators.pattern('^(\([0-9]{3}\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$')]),
      CompanyId: new FormControl('24'),
      VendorType: new FormControl('VendorType'),
      BankContact: new FormControl('BankContact'),
      CustomerId: new FormControl(this.authService.getRegistredUserDetails().customerId),
      CreatedBy: new FormControl(this.authService.getRegistredUserDetails().createdBy),
      W9Verified: new FormControl(true),
      W9VerifiedYear: new FormControl('w9VerifiedYear'),
    }
  )

  onClick() {
    this.customerBankAccountSetupForm.enable();
  }
  onSubmit() {
    this.submitted = true;
    if (this.customerBankAccountSetupForm.valid) {
      if (this.customerBankAccountSetupForm.value.AccountNumber == this.customerBankAccountSetupForm.value.ConfirmAccNum) {
        this.loginService.createBankAccount(this.customerBankAccountSetupForm.value, this.token)
          .subscribe((response) => {
            console.log("Bank : ", response);
            this.alertService.success('Success!! Bank Details Saved SuccessFully.', this.options);
            setTimeout(() => {
              this.router.navigate(['/All/updateBank']);
            }, 1500);
          }, (err) => {
            console.log(err);
            this.alertService.error(err.error.errors.Messages[0], this.options);
          })
      }
      else {
        this.alertService.error('Error!! Account number and confirm account number should be same.', this.options);
      }
    } else {
      console.log("please enter valid data");
      // this.alertService.error('Error :( Please Enter Valid Details!', this.options);
    }
  }

  //bank acc routing num
  routingNum() {
    this.loginService.createBankAccountRoutingNum(this.customerBankAccountSetupForm.value.BankRoutingNumber, this.token).
      subscribe((response: any) => {
        console.log(response);
        console.log(response.bankName);
        this.customerBankAccountSetupForm.patchValue({
          NameOfBank: response.bankName,
          BankRoutingNumber: response.routingNumber,
          BankAddress: response.address,
          BankZipCode: response.zip,
          BankContactPhone: response.telePhone,
        });
        if (response.message !== 'OK') {
          this.alertService.error(response.message, this.options);
        }
      }, (err) => {
        console.log(err);
      })
  }

  get forms() {
    return this.customerBankAccountSetupForm.controls;
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onPress(event) {
    const inputValue = event.target.value;
    const maxDigits = 11;
    if (event.target.value.length > 11) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.customerBankAccountSetupForm.value.BankContactPhone = event.target.value
    }
  }

  routingNumValidations(event) {
    const inputValue = event.target.value;
    const maxDigits = 8;
    if (event.target.value.length > 8) {
      const truncatedValue = inputValue?.slice(0, maxDigits);
      event.target.value = truncatedValue;
      this.customerBankAccountSetupForm.value.BankRoutingNumber = event.target.value
    }
  }

}
